import { render, staticRenderFns } from "./CormackClassification.vue?vue&type=template&id=2222184b&scoped=true"
import script from "./CormackClassification.vue?vue&type=script&lang=js"
export * from "./CormackClassification.vue?vue&type=script&lang=js"
import style0 from "./CormackClassification.vue?vue&type=style&index=0&id=2222184b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222184b",
  null
  
)

export default component.exports